import React from "react";
import CustomBanner from "../Components/CustomBanner/CustomBanner";
import Images from "../Constants/Images";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";
const bannerdata = [
    {
        Bannerimg: Images.Ourteam,
    }
]
const teamdata = [
    {
        name: "Jeffery Khoury",
        title: "President",
        bounceInLeft: "bounceInLeft",
        Images: Images.Jeffery_Khoury
    },
    {
        name: "Stephanie Lammam",
        title: "Executive Vice President",
        Images: Images.Stephanie_Lammam,
        bounceInLeft: "bounceInBottom",
    },
   
    {
        name: "Jonathan Massimo Stinziani ",
        title: "Director of Operations",
        Images: Images.Jonathan_Massimo,
        bounceInLeft: "bounceInRight",
    },
    {
        name: "Kimberly Eid",
        title: "Marketing Manager",
        Images: Images.Cyrille_El,
        bounceInLeft: "bounceInRight",
    }
]
const Team = () => {
    const { t } = useTranslation();
    return (
        <div className="bg-[#e7d5b1]" style={{ backgroundColor: "black" }}>
            <CustomBanner bannerdata={bannerdata} />
            <div className="container ">
                <ScrollAnimation animateIn="bounceInLeft">
                    <div class="cinzel font-48 font-semibold text-center my-10 text-white capitalize" >{t("Our Team")}</div>
                </ScrollAnimation>
                <div className="grid grid-cols-2 max-[900px]:grid-cols-2 max-[600px]:grid-cols-1 gap-10 pb-16">
                    {teamdata.map((President) => (
                        <ScrollAnimation animateIn={'none'}>
                            <div className="Jeffery_Khoury h-full" >
                                <img src={President.Images} className="w-full h-full object-cover" />
                                <div className="absolute bottom-6 hidden text-white left-5">
                                    <div className="cinzel font-48 font-semibold  my-1"> {t(President.name)} </div>
                                    <div className="Optima font-32 capitalize"> {t(President.title)} </div>
                                </div>
                            </div>
                        </ScrollAnimation>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default Team;